/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// NICO'S CODE

// code to change text under add to cart for pre order only on some variant
const pre_order_list = [];
const retrozip_no_preorder_list = [];
const cargo_no_preorder_list = [];
const no_preorder_list = [];
const retrozip_sold_out = [];

function changePreorder(variant){
  var pre_order_box = document.getElementById("container_preorder_box");
    var inventory_box = document.getElementById("container_inventory_box");

  if (pre_order_list.includes(variant.id)){
    console.log("variant changed pre order");
    if (inventory_box){
    inventory_box.style.display = "none";
    }
    
    if (pre_order_box){
    pre_order_box.style.display = 'block';
    }
//       var text_below_cart = document.getElementsByClassName("preorder_text_add_to_cart")[0];
//     console.log(text_below_cart.innerHTML); 
//     text_below_cart.innerHTML = 'Spedizione in 1-5 giorni a partire dal <b>18 Novembre</b>';
    var button_add_to_cart = document.getElementsByClassName("ProductForm__AddToCart")[0];
     button_add_to_cart.innerHTML = 'PRE-ORDINA';
    
    var delivery_text = document.getElementById("delivery_estimate_text")
    delivery_text.innerHTML = 'Pre-order<br>Spedizione dal 3 Dicembre';
    var delm_container = document.getElementsByClassName("delm-delivery-container")[0]
    delm_container.style.display = "none"
    
  }else if(retrozip_no_preorder_list.includes(variant.id) || cargo_no_preorder_list.includes(variant.id) || no_preorder_list.includes(variant.id)){
    
    if (inventory_box){
    inventory_box.style.display = "block";
    }
    
    if (pre_order_box){
    pre_order_box.style.display = 'none';
    }
    
//     var text_below_cart = document.getElementsByClassName("preorder_text_add_to_cart")[0];
//      text_below_cart.innerHTML = '<b>Spedizione in 1-5 giorni</b>';
    
    var button_add_to_cart = document.getElementsByClassName("ProductForm__AddToCart")[0];
     button_add_to_cart.innerHTML = 'AGGIUNGI AL CARRELLO';
    var delivery_text = document.getElementById("delivery_estimate_text")
    delivery_text.innerHTML = 'Consegna prevista';
    var delm_container = document.getElementsByClassName("delm-delivery-container")[0]
    delm_container.style.display = "block"
    
  }else if (retrozip_sold_out.includes(variant.id)){
    var text_below_cart = document.getElementsByClassName("preorder_text_add_to_cart")[0];
     text_below_cart.innerHTML = "";
    var delivery_text = document.getElementById("delivery_estimate_text")
    delvery_text.innerHTML = 'SOLD OUT';
    var delm_container = document.getElementsByClassName("delm-delivery-container")[0]
    delm_container.style.display = "none"
  }
  
}
document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    console.log("variant changed");
  changePreorder(variant)
  
});

const SERVER_URL = "https://abracadabralab.co";

// const BLACK_FRIDAY_POPUP_REF = "black_friday_discount_updates";
const CORONA_POPUP = "corona_popup_show";
// const POPUP_REF = BLACK_FRIDAY_POPUP_REF;

document.addEventListener('product:added', function(event) {
  var product_id = event.detail.variant
  console.log(JSON.stringify(event.detail.variant.id))
  checkIfMysteryBoxAddedToCart(event.detail.variant.id)
  
  
//   console.log('inside ad to cart')
  Shopify.getCart(function(cart){
      	console.log('shopify cart' + JSON.stringify(cart));
        let cart_token = cart.token
        let app_user_id = Cookies.get('app_user_id')
//   		console.log('app_user_id', app_user_id)
        let attributes = {}
        console.log("cart_attributes on product" + JSON.stringify(cart.attributes))
        if (app_user_id && (!("app_user_id" in cart.attributes) || String(cart.attributes.app_user_id) != String(Cookies.get('app_user_id'))) ){
//           console.log("inside app user id not in cart attributes")
          attributes['app_user_id'] = Cookies.get('app_user_id')
        }
    if (!("cart_token" in cart.attributes) || String(cart.attributes.cart_token) != String(cart_token) ){
//     	console.log("inside token not in cart attributes")
      attributes['cart_token'] = cart_token
    }
    if (Object.keys(attributes).length !== 0){
      console.log("inside attributes not empty")
        $.post('/cart/update.js', { attributes : attributes } ).done(
          		function(item) {
            		console.log(JSON.stringify(item))
          	}.bind(this)
        	)
        	.fail(
          		function(response) {
            		console.log(JSON.stringify(response))
          	}.bind(this)
        	)
        
        if (app_user_id){
        	registerAppUserToServer(cart_token, app_user_id)
        }
    }
        });
  });







function goToReturnOrderNumberPage(){
  window.location.href = "https://returns.richcommerce.co/return/new?c=AlienationStore";
}



function setAppIdCookie(app_user_id){
  if(app_user_id !== undefined || app_user_id !== ""){
    Cookies.set('app_user_id',app_user_id,{ expires: 730 })
  }
  console.log('cookie:' + Cookies.get('app_user_id'));
}

function checkIfAppUser(){
 	console.log("inside check if app user");
 	const queryString = window.location.search;
	console.log(queryString);
  	const urlParams = new URLSearchParams(queryString);
  	if (urlParams.has("app_user_id")){
    	if (Cookies.get('app_user_id') != urlParams.get("app_user_id")){
      		setAppIdCookie(urlParams.get("app_user_id"))
      		console.log(urlParams.get("app_user_id"))
    	}else{
    		console.log("user already regitered on cookies"+ urlParams.get("app_user_id"))
    	}
	}
}

function registerAppUserToServer(cart_token, app_user_id){
  	console.log("inside register app user to server")
      $.ajax({
    type: "POST",
    url: SERVER_URL + '/app/registerAppUserId',
        data: {'app_user_id':app_user_id, 'cart_token':cart_token},
    success: function(data) {
        console.log(JSON.stringify(data))
    },
    error: function(xhr){
        console.log(JSON.stringify(xhr))
        // take a look at xhr.status and xhr.responseText
    }
	});
  
}

function openPopUpLocation(){
  
}

function checkIpLocation(){
 $.get("https://ipinfo.io/json", function (response) {
    //here you get details in response.
//    console.log("inside check ip location")
//    console.log(response)
//    var country = response.country
//    console.log(country)
}, "jsonp"); 
  
}
const mystery_variant_ids = [42175170543853,42175170576621,42175170609389,42175170642157,42175170674925,42175170707693,42175170740461,42175170773229,
                            42626629435629,42626629468397,42626629501165,42626629533933,
                            42626626257133,42626626289901,42626626322669,42626626355437,
                            42626637627629,42626637660397,42626637693165,42626637725933]
function checkIfMysteryBoxAddedToCart(variant_id){
  console.log("inside checking mystery box popuo, variant id: "+ variant_id)
  if (mystery_variant_ids.includes(variant_id)){
    
    showMisteryBoxPopUp()
  }
}

function showMisteryBoxPopUp(){
  var docHeight = $(document).height();
     var scrollTop = $(window).scrollTop();
      console.log("111111")
      
      $(document.body).css('overflowY', 'hidden'); 
      $('.transparent-overlay').show().css({'top': 0+'%'});
     $('.popup'+7).show().css({'top': 15+'%'});
      $('.popup'+7).css('overflowY', 'auto');
  
}

window.onload = function() {
	checkIfAppUser()
//  	checkIpLocation()
};
